import { useEffect, useRef } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { useLocation } from 'react-router-dom';

type UseGridRefreshProps = {
  gridRefs: React.RefObject<AgGridReact>[];
  routeName: string;
  onRefresh: () => void;
  dependencies?: any[];
};

export const useGridRefresh = ({
  gridRefs,
  routeName,
  onRefresh,
  dependencies = [],
}: UseGridRefreshProps) => {
  const location = useLocation();
  const onRefreshRef = useRef(onRefresh);

  useEffect(() => {
    onRefreshRef.current = onRefresh;
  }, [onRefresh]);

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const currentRoute = pathSegments[pathSegments.length - 1];
    const isMatchingRoute =
      !currentRoute || currentRoute === 'semen' || currentRoute === routeName;

    if (!isMatchingRoute) return;

    const waitForGridsAndRefresh = () => {
      const allGridsReady = gridRefs.every((ref) => ref.current?.api);

      if (allGridsReady) {
        onRefreshRef.current();
      } else {
        setTimeout(waitForGridsAndRefresh, 50);
      }
    };

    const timeoutId = setTimeout(waitForGridsAndRefresh, 100);
    return () => clearTimeout(timeoutId);
  }, [location.pathname, routeName, ...dependencies]);
};
